module.exports = __webpack_public_path__ + "img/P951.fec4a96c.jpg";